/* eslint-disable prettier/prettier */
import styled, { css } from 'styled-components';

interface ContactProps {
  isPage?: boolean;
}

export const Main = styled.div<ContactProps>`
  .title {
    color: var(--purple-light);
    align-items: center;
    text-align: center;
    display: flex;
    flex-direction: column;
    margin-top: 0em;
    margin-bottom: 2rem;

    ${props =>
    // eslint-disable-next-line prettier/prettier
    props.isPage &&
    css`
        margin-top: 3rem;
        margin-bottom: 1.5rem;
        align-items: center;
      `}

    @media (max-width: 768px) {
      flex-wrap: wrap;
      margin-bottom: 2rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }

  svg {
    color: #424b5a;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    color: var(--purple-light);
    font-size: 2.5rem;

    @media (max-width: 768px) {
      flex-wrap: wrap;
      width: 90%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
  }
`;

export const GridContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1rem;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    margin-top: 1rem;
    margin-bottom: 2rem;
    width: 95%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

export const FormDiv = styled.div<ContactProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid var(--gray-line);
  margin: 2%;
  padding: 2%;
  border-radius: 18px;
`;

export const FormWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: left;
  flex-direction: column;
  width: 100%;
  .input-container {
   text-align: center;
   font-size: 16px;
  }

  .categoria {
    padding: 1;
  }
`;

export const FileDiv = styled.div`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px;
  max-width: 100%;
  p {
    margin-bottom: 10px;
    font-weight: normal;
    font: "Source Sans Pro", sans-serif;
    @media (max-width: 800px) {
      font-size: 10px;
    }
    @media (max-width: 600px) {
      font-size: 10px;
    }
  }
`;
